<mat-button-toggle-group (change)="onClick($event)" [formControl]="formControl" [ngClass]="{'new-line': newLine}"
                         [ngStyle]="{'height': height}" id="button-toggle">
    <mat-button-toggle *ngFor="let button of listOfButtons" [attr.value]="button.value === selectedValue"
                       [value]="button.value"
                       id="{{buttonToggleName}}-{{button.text}}"
                       class="button-toggle-element">{{button.text}}</mat-button-toggle>
</mat-button-toggle-group>
